import { useQuery } from '@tanstack/react-query'
import { api } from '@metal/ui/api'

export interface SettingsSummary {
  subUsers: number
  /** Null when the document library did not answer: the row loses its count. */
  documents: number | null
}

export const SETTINGS_SUMMARY_KEY = ['settings', 'summary'] as const

export function useSettingsSummary() {
  return useQuery({
    queryKey: SETTINGS_SUMMARY_KEY,
    queryFn: () => api.get<SettingsSummary>('/settings/summary'),
    staleTime: 5 * 60_000,
  })
}
